var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("配置保费模版"),
      visible: _vm.dialogVisible,
      width: 1200,
      footer: null
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("方案信息")))])]), _c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("方案名称")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.dataFrom.name,
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("方案代码")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.dataFrom.code || "-",
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "cont",
    attrs: {
      label: _vm.$t("保费")
    }
  }, [_vm.dataFrom.priceType != "AREA_PRICE" ? _c("a-input", {
    attrs: {
      value: _vm.dataFrom.price || "-",
      readOnly: true
    }
  }) : _vm._e(), _vm.dataFrom.priceType == "AREA_PRICE" ? _c("a-input", {
    attrs: {
      value: _vm.dataFrom.price[0] || "-",
      readOnly: true
    }
  }) : _vm._e(), _vm.dataFrom.priceType == "AREA_PRICE" ? _c("span", {
    staticStyle: {
      margin: "0 5px"
    }
  }, [_vm._v("~")]) : _vm._e(), _vm.dataFrom.priceType == "AREA_PRICE" ? _c("a-input", {
    attrs: {
      value: _vm.dataFrom.price[1] || "-",
      readOnly: true
    }
  }) : _vm._e(), _c("span", {
    staticStyle: {
      margin: "0 5px",
      display: "flex",
      "flex-shrink": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))))])], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "cont",
    attrs: {
      label: _vm.$t("保障金额")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.dataFrom.amount || "-",
      readOnly: true
    }
  }), _c("span", {
    staticStyle: {
      margin: "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false))))])], 1)], 1)], 1)], 1), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保费模板")))])]), _c("a-alert", {
    attrs: {
      type: "error"
    }
  }, [_c("div", {
    attrs: {
      slot: "description"
    },
    slot: "description"
  }, [_vm._v(" " + _vm._s(_vm.$t("以下为折扣后保费的计算公式，请按照实际业务情况进行配置"))), _c("br"), _vm._v(" " + _vm._s(_vm.$t("折扣比例：保费-保费*折扣比例=折扣后保费"))), _c("br"), _vm._v(" " + _vm._s(_vm.$t("折扣金额：保费-折扣金额=折扣后保费")) + " ")])]), _vm.dataFrom.priceType == "AREA_PRICE" ? _c("a-collapse", {
    staticClass: "marginT20",
    attrs: {
      "expand-icon-position": "right"
    },
    model: {
      value: _vm.activeKey,
      callback: function ($$v) {
        _vm.activeKey = $$v;
      },
      expression: "activeKey"
    }
  }, _vm._l(_vm.premiumTemplateList, function (item, index) {
    return _c("a-collapse-panel", {
      key: String(item.areaIndex),
      attrs: {
        header: _vm.$t("保费") + "(" + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false)) + ")：" + item.price
      }
    }, [_c("premium-form", {
      attrs: {
        list: item.premiumTemplateList,
        isEdit: item.isEdit,
        name: item.areaCodeName,
        price: item.price,
        index: index,
        structureList2: _vm.structureLists
      },
      on: {
        edit: _vm.handleEdit,
        tree: _vm.handleTree,
        cancel: _vm.handleCancel,
        save: _vm.handleSave
      }
    })], 1);
  }), 1) : _c("div", [_c("premium-form", {
    attrs: {
      list: _vm.premiumTemplateList,
      isEdit: true,
      price: _vm.dataFrom.price,
      index: 0,
      structureList2: _vm.structureLists
    },
    on: {
      edit: _vm.handleEdit,
      tree: _vm.handleTree,
      cancel: _vm.handleCancel,
      save: _vm.handleSave
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };